<template>
    <div class="row justify-content-center align-items-center login-fixed" id="register">
        <div class="col-md-6 col-11">
            <card class="card-signup text-center" no-footer-line>
                <template slot="header">
                    <h4 class="card-title">Login</h4>
                </template>

                <fg-input
                    v-model="login.email"
                    placeholder="E-Mail"
                    @keyup.enter.native="submit()"/>
                <fg-input
                    v-model="login.password"
                    placeholder="Password"
                    type="password"
                    @keyup.enter.native="submit()"/>

                <div class="d-flex justify-content-end">
                    <router-link :to="{ name: 'forgot-password' }">
                        <n-button type="neutral">Forgot Password ?</n-button>
                    </router-link>
                </div>

                <div slot="footer">
                    <n-button
                        :loading="loading"
                        class="btn btn-primary btn-round btn-lg"
                        @click.native="submit()">
                            Sign In
                    </n-button>
                    <!-- <div class="d-flex justify-content-center">
                        <router-link :to="{ name: 'register' }">
                            <n-button type="neutral">Don't have an account ? Sign up</n-button>
                        </router-link>
                    </div> -->
                </div>
            </card>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            loading: false,
            login: {
                email: '',
                password: ''
            }
        }
    },
    mounted () {
        if (this.$route.query.verificationCode && this.$route.query.verificationCode.length) {
            this.verifyUser()
        }

        if (this.$route.query.resetCode && this.$route.query.resetCode.length) {
            this.$router.push({ name: 'update-password', query: { resetCode: this.$route.query.resetCode } })
        }
    },
    methods: {
        submit: async function () {
            this.loading = true
            try {
                const response = await this.$store.dispatch('login', this.login)

                if (response.data.user.event) {
                    this.$router.push({ name: 'dashboard', params: { eventId: response.data.user.event } })
                    return
                }

                this.$router.push({ name: 'events' })
            } catch (e) {
                console.log(e)
                let message = 'Invalid credentials'
                if (e.response.data.message) {
                    message = e.response.data.message
                }

                this.$notify({ type: 'danger', message })
            }
            this.loading = false
        },
        verifyUser: async function () {
            this.loading = true
            try {
                await this.$store.dispatch('verifyUser', {
                    code: this.$route.query.verificationCode
                })
                this.$notify({ type: 'success', message: 'Account was successfully verified!' })
                this.$router.push({ name: 'events' })
            } catch (e) {
                console.log('error on user verification')
            }
            this.loading = false
        },
    }
}
</script>
<style>
.login-fixed {
    width: 100vw;
    height: 100vh;
}
</style>